import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { DynamicGuardService } from '@workflow/dynamic-guard/dynamic-guard.decorator';
import { AlloyService } from '@workflow/ecp-workflow/dynamic-app/service/alloy/alloy.service';
/**
 * Guard used to restrict user to leave page if PID verification in progress.
 * A confirmation pop-up will be presented to user and response will be passed to guard using observable
 */
@DynamicGuardService('AlloyCheck')
@Injectable({
  providedIn: 'root'
})
export class AlloyCheckGuard {
  constructor(private readonly router: Router, private readonly alloySvc: AlloyService) {}

  /**
   * Activating page route by checking if alloy is enabled for workflow
   * Activate Alloy Verification based on following confdition
   * * Enable only when Alloy Config exists and isEnabled flag set to true
   * * Enable if no journey is selected for a product / membership.
   * * Enable if any journey other than "none" is selected for a product / membership.
   */
  public canActivate(): boolean {
    const alloyState = this.alloySvc.isAlloyEnabled();
    if (alloyState.state === 'reject' && this.alloySvc.isDeniedBlocking()) {
      this.router.navigateByUrl('/contact-us');
      // we don't want to even attempt activating - off-ramp
      return false;
    }
    return alloyState.enabled;
  }

  public canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    // we aren't blocking that since it is a modal they can hit multiple times until completed
    return true;
  }
}
